import {API_URL, apiPost} from '../api'
import {ApiRes} from '../../types/api'
import {IVolumeLeague, ILeagueSlotId, IVolumeLeagueMarket, LeagueVisibility} from './list'

/**
 * POST /v3/admin/volume-league — 리그 생성 (rolling | competition)
 *
 * Validation (서버):
 *  - name 필수
 *  - kind ∈ {rolling, competition}
 *  - scope_type ∈ {exchange, symbol, markets}
 *  - exchange scope → 유효한 exchange 필요 / symbol scope → symbol 필요
 *  - markets scope → markets 필수 (지원 시장만, 중복 불가). symbol/exchange 생략 시 서버가 markets 로 채움
 *  - visibility ∈ {public, managers} (생략 = public)
 *  - rolling → window_days > 0
 *  - competition → start_at < end_at
 *  - supported_exchanges 각 항목은 known exchange (소문자/중복제거 정규화)
 *  - exchange_urls 키는 known exchange(소문자), 값은 절대 http/https URL(최대 512자), 최대 64개
 *  - prize_pool 있으면 total_amount > 0 && currency 필요 (currency 대문자화)
 *  - sort_value 선택 (생략/0 = 기본 newest-first 순서, 내림차순 정렬 가중치)
 *  - slot_id 선택 ({ ko, en } 언어별 Slot 식별자, 표시 전용)
 * 검증 실패 시 status: 5050 + message 반환.
 */
export interface ICreateVolumeLeagueBody {
    name: string
    kind: IVolumeLeague['kind']
    scope_type: IVolumeLeague['scope_type']
    exchange?: string
    symbol?: string
    supported_exchanges?: string[]
    exchange_urls?: {[exchange: string]: string}
    window_days?: number
    refresh_interval_sec?: number
    prize_pool?: IVolumeLeague['prize_pool']
    start_at?: string
    end_at?: string
    url_third_party?: string
    sort_value?: number
    slot_id?: ILeagueSlotId
    mobile_slot_id?: ILeagueSlotId
    visibility?: LeagueVisibility
    markets?: IVolumeLeagueMarket[]
}

export const createVolumeLeague = async (data: ICreateVolumeLeagueBody): Promise<ApiRes<IVolumeLeague>> => {
    return await apiPost(API_URL, 'admin/volume-league', data)
}
